import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { ItemCardComponent } from 'src/app/components/item-card/item-card.component';
import { ItemListComponent } from '../components/item-list/item-list.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { SearchResultsComponent } from '../components/search-results/search-results.component';
import { NotificationsListComponent } from '../components/notifications-list/notifications-list.component';
import { HelpComponent } from '../components/help/help.component';
import { ProfileListComponent } from '../components/profile-list/profile-list.component';
import { WelcomeTourComponent } from '../components/welcome-tour/welcome-tour.component';
import { AnnouncementsComponent } from '../components/announcements/announcements/announcements.component';
import { ListSelectionComponent } from '../components/list-selection/list-selection.component';
import { ListEditComponent } from '../components/list-edit/list-edit.component';
import { MoreInfoComponent } from '../components/more-info/more-info.component';
@NgModule({
  declarations: [
    ItemListComponent,
    ItemCardComponent,
    SearchResultsComponent,
    NotificationsListComponent,
    HelpComponent,
    ListSelectionComponent,
    ListEditComponent,
    ProfileListComponent,
    WelcomeTourComponent,
    AnnouncementsComponent,
    MoreInfoComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    ItemListComponent,
    ItemCardComponent,
    SearchResultsComponent,
    NotificationsListComponent,
    HelpComponent,
    ListSelectionComponent,
    ListEditComponent,
    ProfileListComponent,
    WelcomeTourComponent,
    AnnouncementsComponent,
    MoreInfoComponent
  ]
})
export class SharedModule { }
